import type { AdministrationContentPage } from "@kontextwerk/control-web-frame/shared/logic/administration"

export const pageConfig: AdministrationContentPage = {
  id: "phone",
  title: "Telefonvorlagen",
  path: "phone",
  tabs: [
    ["outbound", "Ausgehend"],
    ["inbound", "Eingehend"],
  ].map(([purpose, title]) => ({
    id: `phone-${purpose}`,
    title,
    routeSegment: purpose.replaceAll("_", "-"),
    widthType: "normal",
    testId: `controlAdmin.organizationView.announcementTemplates.phone.${purpose}`,
  })),
}
